"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _authActionKeys = _interopRequireDefault(require("./authActionKeys"));

var _redux = require("redux");

var _AsyncRequest = _interopRequireDefault(require("../AsyncRequest"));

var _createReducer2 = _interopRequireDefault(require("../createReducer"));

var _createReducer;

var login = _AsyncRequest.default.createReducer(_authActionKeys.default.LOGIN);

var logout = _AsyncRequest.default.createReducer(_authActionKeys.default.LOGOUT);

var requestPasswordReset = _AsyncRequest.default.createReducer(_authActionKeys.default.REQUEST_PASSWORD_RESET);

var resetPassword = _AsyncRequest.default.createReducer(_authActionKeys.default.RESET_PASSWORD);

var isAuthenticated = (0, _createReducer2.default)(false, (_createReducer = {}, (0, _defineProperty2.default)(_createReducer, _authActionKeys.default.SET_IS_AUTHENTICATED, function (state, action) {
  return action.payload;
}), (0, _defineProperty2.default)(_createReducer, "GET_USER_SUCCESS", function GET_USER_SUCCESS() {
  return true;
}), (0, _defineProperty2.default)(_createReducer, "GET_USER_ERROR", function GET_USER_ERROR() {
  return false;
}), (0, _defineProperty2.default)(_createReducer, _authActionKeys.default.CHANGE_AUTH_PAGE, function (state, action) {
  action.addSideEffect(function (store) {
    store.dispatch(_authActionKeys.default.LOGIN_RESET);
    store.dispatch(_authActionKeys.default.LOGOUT_RESET);
    store.dispatch(_authActionKeys.default.REQUEST_PASSWORD_RESET_RESET);
    store.dispatch(_authActionKeys.default.RESET_PASSWORD_RESET);
  });
  return state;
}), _createReducer), false);

var getPasswordResetInfo = _AsyncRequest.default.createReducer(_authActionKeys.default.GET_PASSWORD_RESET_INFO);

var resetPasswordAndLogin = _AsyncRequest.default.createReducer(_authActionKeys.default.RESET_PASSWORD_AND_LOGIN);

var sendMagicLink = _AsyncRequest.default.createReducer(_authActionKeys.default.SEND_MAGIC_LINK);

var validateMagicLink = _AsyncRequest.default.createReducer(_authActionKeys.default.VALIDATE_MAGIC_LINK);

var _default = (0, _redux.combineReducers)({
  isAuthenticated: isAuthenticated,
  login: login,
  logout: logout,
  requestPasswordReset: requestPasswordReset,
  resetPassword: resetPassword,
  resetPasswordAndLogin: resetPasswordAndLogin,
  getPasswordResetInfo: getPasswordResetInfo,
  sendMagicLink: sendMagicLink,
  validateMagicLink: validateMagicLink
});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/auth/authReducer.js
// module id = 4352
// module chunks = 25